module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-layout', {
    staticClass: "list-layout",
    attrs: {
      "pageSize": _vm.pageSize,
      "currentPage": _vm.currentPage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleChange,
      "size-change": _vm.handleSizeChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("委托库查询")]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "slot": "btn_tabs"
    },
    slot: "btn_tabs"
  }, [_c('el-tabs', {
    staticClass: "tab",
    attrs: {
      "value": _vm.typename
    },
    on: {
      "tab-click": _vm.btnTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "disabled": _vm.IsLoading,
      "label": "委托总库",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "disabled": _vm.IsLoading,
      "label": "自己委托库",
      "id": "self",
      "name": "self"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "slot": "search-bar",
      "inline": true
    },
    slot: "search-bar"
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料名称"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请输入物料名称／物料编码／客户物料名称／客户物料编码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.Search.Product),
      callback: function($$v) {
        _vm.Search.Product = $$v
      },
      expression: "Search.Product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入区域"
    },
    model: {
      value: (_vm.Search.Region),
      callback: function($$v) {
        _vm.Search.Region = $$v
      },
      expression: "Search.Region"
    }
  }, _vm._l((_vm.Regions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入品牌"
    },
    on: {
      "change": _vm.changeBrand
    },
    model: {
      value: (_vm.Search.BrandName),
      callback: function($$v) {
        _vm.Search.BrandName = $$v
      },
      expression: "Search.BrandName"
    }
  }, _vm._l((_vm.BrandNames), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机型"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入机型"
    },
    on: {
      "change": _vm.changeModels
    },
    model: {
      value: (_vm.Search.ProductModel),
      callback: function($$v) {
        _vm.Search.ProductModel = $$v
      },
      expression: "Search.ProductModel"
    }
  }, _vm._l((_vm.ProductModels), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入模块"
    },
    model: {
      value: (_vm.Search.ProductModule),
      callback: function($$v) {
        _vm.Search.ProductModule = $$v
      },
      expression: "Search.ProductModule"
    }
  }, _vm._l((_vm.ProductModules), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), (_vm.typename == 'self') ? _c('el-form-item', {
    attrs: {
      "label": "品项"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入品项"
    },
    model: {
      value: (_vm.Search.ProductCondition),
      callback: function($$v) {
        _vm.Search.ProductCondition = $$v
      },
      expression: "Search.ProductCondition"
    }
  }, _vm._l((_vm.ProductConditions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.IsLoading
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "slot": "tabs"
    },
    slot: "tabs"
  }, [_c('el-tabs', {
    staticClass: "tab",
    attrs: {
      "value": _vm.activename
    },
    on: {
      "tab-click": _vm.handleTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "可租可售",
      "name": "rent_sales"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "只售",
      "name": "sales"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "只租",
      "name": "rent"
    }
  }), _vm._v(" "), (_vm.typename == 'self') ? _c('el-tab-pane', {
    attrs: {
      "label": "委托到期物料",
      "name": "managed"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    staticClass: "table_area",
    attrs: {
      "slot": "table_area",
      "element-loading-text": "加载中"
    },
    slot: "table_area"
  }, [(_vm.typename == 'all') ? _c('div', {
    staticClass: "order-box"
  }, [(_vm.activename == 'rent_sales' || _vm.activename == 'sales') ? _c('el-button', {
    staticClass: "add-btn1",
    nativeOn: {
      "click": function($event) {
        _vm.toPurchase()
      }
    }
  }, [_vm._v("采购询价单\n          "), (this.purchasebox.length !== 0) ? _c('span', [_vm._v(_vm._s(this.purchasebox.length))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activename == 'rent_sales' || _vm.activename == 'rent') ? _c('el-button', {
    staticClass: "add-btn",
    nativeOn: {
      "click": function($event) {
        _vm.toLeaseapply()
      }
    }
  }, [_vm._v("租赁申请单\n          "), (this.leaseapplybox.length != 0) ? _c('span', [_vm._v(_vm._s(this.leaseapplybox.length))]) : _vm._e()]) : _vm._e()], 1) : _c('div', {
    staticClass: "order-box"
  }, [(_vm.activename != 'managed') ? _c('el-button', {
    staticClass: "add-btn1",
    nativeOn: {
      "click": function($event) {
        _vm.toManagedShip()
      }
    }
  }, [_vm._v("发货通知单\n          "), (this.shipbox.length !== 0) ? _c('span', [_vm._v(_vm._s(this.shipbox.length))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activename != 'managed') ? _c('el-button', {
    staticClass: "add-btn",
    nativeOn: {
      "click": function($event) {
        _vm.toManagedApply()
      }
    }
  }, [_vm._v("调度申请单\n          "), (this.managedbox.length !== 0) ? _c('span', [_vm._v(_vm._s(this.managedbox.length))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activename == 'managed') ? _c('p', {
    staticClass: "pull-left"
  }, [_vm._v("联系客服寄回：0755-82405890")]) : _vm._e(), _vm._v(" "), (_vm.activename == 'managed') ? _c('el-button', {
    staticClass: "add-btn",
    attrs: {
      "disabled": this.batchSelection.length === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.toTrustActive()
      }
    }
  }, [_vm._v("激活委托"), (this.activebox.length !== 0) ? _c('span', [_vm._v(_vm._s(this.activebox.length))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.activename != 'managed') ? _c('table', [_c('thead', [_c('tr', [_c('td', [_vm._v("物料名称／编码")]), _vm._v(" "), _c('td', [_vm._v("客户物料名称／编码")]), _vm._v(" "), _c('td', [_vm._v("品项")]), _vm._v(" "), _c('td', [_vm._v("品牌")]), _vm._v(" "), _c('td', [_vm._v("机型")]), _vm._v(" "), _c('td', [_vm._v("模块")]), _vm._v(" "), _c('td', [_vm._v("库存数量")]), _vm._v(" "), _c('td', [_vm._v("区域")]), _vm._v(" "), _c('td', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "260"
      }
    }, [_vm._v("\n              " + _vm._s(item.ProductName)), _c('br'), _vm._v("物料编码： " + _vm._s(item.ProductCode) + "\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "240"
      }
    }, [_vm._v(_vm._s(item.CustomerProductName)), _c('br'), _vm._v("物料编码： " + _vm._s(item.CustomerProductCode))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [(item.ConditionName != null) ? _c('el-tag', {
      attrs: {
        "type": _vm._f("ConditionColor")(item.ConditionName)
      }
    }, [_vm._v(_vm._s(item.ConditionName))]) : _vm._e(), _vm._v(" "), (item.ConditionName == null) ? _c('span', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v(_vm._s(item.ProductBrandName))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "200"
      }
    }, [_vm._v(_vm._s(item.ProductModelName))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "120"
      }
    }, [_vm._v(_vm._s(item.ProductModuleName))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v(_vm._s(item.Quantity))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v(_vm._s(item.RegionName))]), _vm._v(" "), (_vm.typename == 'all') ? _c('td', {
      attrs: {
        "width": "250"
      }
    }, [(_vm.activename == 'rent_sales' || _vm.activename == 'rent') ? _c('div', {
      staticClass: "allweare"
    }, [(_vm.ifAddLeaseapply(item) && item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.addLeaseapply(item)
        }
      }
    }, [_vm._v("加入租赁")]) : (!_vm.ifAddLeaseapply(item) || item.Quantity > 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.cancelLeaseapply(item)
        }
      }
    }, [_vm._v("取消加入租赁")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activename == 'rent_sales' || _vm.activename == 'sales') ? _c('div', {
      staticClass: "allweare"
    }, [(_vm.ifAddPurchase(item)) ? _c('el-button', {
      attrs: {
        "type": "warning",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.addPrice(item)
        }
      }
    }, [_vm._v("加入询价")]) : _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.cancelPricebtn(item)
        }
      }
    }, [_vm._v("取消加入询价")])], 1) : _vm._e()]) : _c('td', {
      attrs: {
        "width": "300"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.todetail(item)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), (_vm.ifAddManaged(item) && item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.addManaged(item)
        }
      }
    }, [_vm._v("加入调度")]) : (!_vm.ifAddManaged(item) || item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.cancelManaged(item)
        }
      }
    }, [_vm._v("取消加入调度")]) : _vm._e(), _vm._v(" "), (_vm.ifAddInvoice(item) && item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.addInvoice(item)
        }
      }
    }, [_vm._v("加入发货")]) : (!_vm.ifAddInvoice(item) || item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.cancelInvoice(item)
        }
      }
    }, [_vm._v("取消加入发货")]) : _vm._e()], 1)])
  }))]) : _vm._e(), _vm._v(" "), (_vm.total === 0 && _vm.is_checked === 0) ? _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.newsend,
      "rules": _vm.rules
    }
  }, [_c('table', {
    staticClass: "newbox"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_c('p', {
    staticClass: "canadd"
  }, [_vm._v("抱歉，没有找到您要的产品")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.activename == 'managed') ? _c('el-table', {
    ref: "multipleTable",
    staticClass: "timedata",
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductCode",
      "label": "批次号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-col', [_vm._v(_vm._s(prop.row.ProductName))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码：" + _vm._s(prop.row.ProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品项",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [(prop.row.ConditionName != null) ? _c('el-tag', {
          attrs: {
            "type": _vm._f("ConditionColor")(prop.row.ConditionName)
          }
        }, [_vm._v(_vm._s(prop.row.ConditionName))]) : _vm._e(), _vm._v(" "), (prop.row.ConditionName == null) ? _c('span', [_vm._v("-")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductBrandName",
      "label": "品牌",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductModelName",
      "label": "机型",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductModuleName",
      "label": "模块",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Quantity",
      "label": "数量",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "RegionName",
      "label": "区域",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "EntrustDay",
      "label": "委托时长",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "RemainingTime",
      "label": "到期时间",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              _vm.todetailManaged(prop)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "pop-box",
    attrs: {
      "title": "委托激活",
      "size": "small"
    },
    model: {
      value: (_vm.managedActiveFormVisible),
      callback: function($$v) {
        _vm.managedActiveFormVisible = $$v
      },
      expression: "managedActiveFormVisible"
    }
  }, [_c('p', [_vm._v("你正在对\n          "), _c('span', {
    staticStyle: {
      "color": "#20a0ff"
    }
  }, [_vm._v(_vm._s(this.batchSelection.length))]), _vm._v(" 个批次进行延长委托的操作，请选择希望延长的时长：")]), _vm._v(" "), _c('el-select', {
    staticClass: "form-input",
    attrs: {
      "filterable": "",
      "placeholder": "请选择委托时长"
    },
    model: {
      value: (_vm.managedTime),
      callback: function($$v) {
        _vm.managedTime = $$v
      },
      expression: "managedTime"
    }
  }, _vm._l((_vm.managedTimes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureActive()
      }
    }
  }, [_vm._v("提交并等待客服联系")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c809e4f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Inventory/TrustListPage.vue
// module id = 748
// module chunks = 0